const PATH_TO_CONFIG = '/resources/configuration.json';

const handleFetchError = (response: Response, path: string) => {
    if (!response.ok) {
        alert('Scenario configuration file not found. Please try again later.');

        const ERROR_MESSAGE = `Failed to fetch scenario configuration file ${path}`;
        console.error(ERROR_MESSAGE);
        throw new Error(ERROR_MESSAGE);
    }
};

export const fetchConfig = async () => {
    const response = await fetch(PATH_TO_CONFIG);
    handleFetchError(response, PATH_TO_CONFIG);
    return response.json();
};